module.exports = __webpack_public_path__ + "img/android.1df875f4.png";